import { findArray } from 'helpers/utils';
import MirsTable from 'components/general/table/Table.js';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import CaptionTable from 'components/general/table/CaptionTable';

const TeamStatistics = ({ data, statsConfig, order }) => {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  const setHeaderBold = (cellInfo) =>{
    if (!cellInfo.row.original.code && cellInfo?.column?.id === 'Stat') {
      return {className: (cellInfo?.column?.className || '') + ' fw-bold' }
    }
    return {className: (cellInfo?.column?.className || '') }
  }

  const team = data?.items?.find(i => i?.startOrder === order)
  const stats = team?.statsItems;

   const caption = (<>
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc className='me-1' {...team?.participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...team?.participant}/>
      </strong>
    </div>
  </>)

  const getStat = (row, period, stats) => {
    switch (row.type){
      case '0' :
        return ''
      
      case '1':
        if (row.data === 'VALUE')
          return stats?.find(s => s?.code === row.code && s?.pos === period)?.value || '-';
        else if (row.data === 'ATTEMPT')
          return stats?.find(s => s?.code === row.code && s?.pos === period)?.attempt || '-';
        else if (row.data === 'PERCENT')
          return stats?.find(s => s?.code === row.code && s?.pos === period)?.percent || '-';
        else
          return '';
      
      case '2':
        if (row.extendedData === 'VALUE')
          return stats?.find(s => s?.code === row.code && s?.pos === period)?.extendedStatsItems?.find(e => e?.code === row.extendedCode)?.value || '-';
        else
          return ''

      case '3':
        const stat_ = stats?.find(s => s?.code === row.code && s?.pos === period);
        if (row.data === 'VALUE' && row.data2 === 'ATTEMPT')
          return stat_ && stat_?.value && stat_?.attempt ? `${stat_?.value}/${stat_?.attempt}` : '-'
        else
          return '';
      
      default:
        return '';
    }
  }

  const tableColumns = useMemo(() => {return [
    {
      id: 'Stat',
      Header: <></>,
      accessor: 'index',
      className: 'text-start w-40',
      headerClassName:'text-start w-40',
      Cell: (props) => {
        let row = props.cell.row.original
        return (
          <Label data={row.label}/>
        )
      }
    },
    {
      id: 'P1',
      Header: <Label data='HeaderP1' />,
      accessor: 'index',
      headerClassName : 'text-center w-10',
      className: 'text-center',
      Cell: (props) => {
        let row = props.cell.row.original
        return getStat(row, 'P1', stats);
      }
    },
    {
      id: 'P2',
      Header: <Label data='HeaderP2' />,
      accessor: 'index',
      headerClassName : 'text-center w-10',
      className: 'text-center',
      Cell: (props) => {
        let row = props.cell.row.original
        return getStat(row, 'P2', stats);
      }
    },
    {
      id: 'P3',
      Header: <Label data='HeaderP3' />,
      accessor: 'index',
      headerClassName : 'text-center w-10',
      className: 'text-center',
      Cell: (props) => {
        let row = props.cell.row.original
        return getStat(row, 'P3', stats);
      }
    },
    {
      id: 'P4',
      Header: <Label data='HeaderP4' />,
      accessor: 'index',
      headerClassName : 'text-center w-10',
      className: 'text-center',
      Cell: (props) => {
        let row = props.cell.row.original
        return getStat(row, 'P4', stats);
      }
    },
    {
      id: 'Total',
      Header: <Label data='HeaderTotal' />,
      accessor: 'index',
      headerClassName : 'text-center w-10 fw-bold',
      className: 'text-center fw-bold',
      Cell: (props) => {
        let row = props.cell.row.original
        return getStat(row, 'TOT', stats);
      }
    }

  ]}, [data]);

  return (
    <MirsTable
      id={`mirs-table-team-statistics-${mirs_rsc}`}
      data={statsConfig}
      columns={tableColumns}
      showLoading={false}
      caption={caption}
      initialSortBy= {[{ id: 'Stat', desc: false }]}
      getCellProps={cellInfo => {return setHeaderBold(cellInfo) }}
    />
  )
}

export default TeamStatistics;